<template>
    <div class="article-privates-hero">
        <p>Lauren is keen to work with dancers on a one-to-one basis.</p>
        <p>
            She has a fun and friendly style - pointing out what you are doing well - as well as identifying areas where
            you can make improvements.
        </p>
        <p>The obvious choice is to meet up at an event, but Lauren can also work with you remotely.</p>
        <h2 class="text-xl font-bold mb-6">How can she help?</h2>
        <ul>
            <li>In person at an event</li>
            <li>Online as a video call</li>
            <li>Video review with written feedback</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticlePrivatesHero',
};
</script>
